import React from 'react';
import { motion } from 'framer-motion';
import { PhoneFrame } from './PhoneFrame';
import { screens } from '../data/screens';
export function HistorySection() {
  return <section className="bg-white py-16 lg:py-20" data-id="element-181" data-mp="11s8m57n7t8xs">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-182" data-mp="11tk183m42347">
        <div className="grid items-center gap-10 rounded-[2.5rem] bg-[#FFFBF2] p-8 sm:p-12 lg:grid-cols-12 lg:gap-14 lg:p-14" data-id="element-183" data-mp="16rbp8mjmx534">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-7" data-id="element-184" data-mp="1ugo2bxi31xap">
            <h2 className="mb-4 text-2xl font-black leading-tight tracking-tight text-kitty-dark md:text-3xl lg:text-4xl" data-id="element-185" data-mp="1pq7ls4iytvk4">
              Nothing mysteriously disappears.
            </h2>
            <p className="max-w-md text-lg leading-relaxed text-gray-600" data-id="element-186" data-mp="2ddp9noz409ht">
              Review expenses, payments and closed kitties whenever you need
              them.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1]
        }} className="mx-auto w-full max-w-[260px] lg:col-span-5 lg:max-w-[280px]" data-id="element-187" data-mp="3uo0cc5g5wtxn">
            <PhoneFrame screen={screens.history} data-id="element-188" data-mp="m7f9z7i1cz3i" />
          </motion.div>
        </div>
      </div>
    </section>;
}